module.exports = __webpack_public_path__ + "img/baño.67c9e8e3.svg";